const reload = process.env.REACT_APP_NAME + "_reload" ;

export default reload ;